import { ReactElement } from "react";
import ReactDOMServer from "react-dom/server";
import { arrayToString } from "common/utils/array";

export const jsxToString = (jsx: ReactElement) =>
  ReactDOMServer.renderToString(jsx);

export const classNames = (classes: string[]) => arrayToString(classes, " ");
